module.exports = __webpack_public_path__ + "static/media/022.e5803a90.jpg";